import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material";

import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import { SHARE_OF_SEARCH_ROUTES } from "@constants";
import { isSystemBusy } from "@signals";
import ShareOfSearchStatusFilters from "./Filters";
import { shareOfSearchStatusIsEmpty, resetShareOfSearchStatus } from "./@signals";
import ShareOfSearchStatusTable from "./Table";
import ShareOfSearchStatusScoreMapChart from "./ScoreMapChart";

export default function ShareOfSearchStatusPage() {

    useEffect(() => {
        return () => resetShareOfSearchStatus()
    }, [])

    return <PageWrapper
        tourPageKey="sosStatus"
        head={`DIP Insight | ${SHARE_OF_SEARCH_ROUTES.STATUS_TITLE}`}
        title={SHARE_OF_SEARCH_ROUTES.STATUS_TITLE}
        subtitle={SHARE_OF_SEARCH_ROUTES.STATUS_SUBTITLE}
        isEmpty={shareOfSearchStatusIsEmpty.value}
        filters={<ShareOfSearchStatusFilters />}
        hasErrors={isSystemBusy.value}
    >
        <Grid container spacing={3}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="sos-status-table" height={350} />
                <ShareOfSearchStatusTable />
            </Grid>
            <Grid item xs={12}>
                <ShareOfSearchStatusScoreMapChart />
            </Grid>
        </Grid>
    </PageWrapper>
}